import React from 'react';
import PropTypes from 'prop-types';

const BookingReference = ({ children }, context) => {
  if (!children) {
    return null;
  }
  return (
    <div className="flex mb-4 md:mb-0 md:flex-col text-sm text-gray-500 items-center md:items-start -mx-1">
        <div className="mx-1">
        {context.t('Booking reference')}
        </div>
        <div className="mx-1 uppercase text-teal-500 font-bold text-xl tracking-wide">
        {children}
        </div>
    </div>
  );
};

BookingReference.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default BookingReference;
